export const brandColors = {
  // Brand colors
  brand20: '#00265E',
  brand30: '#003076',
  brand40: '#00398D',
  brand50: '#0042A5',
  brand60: '#114AB0',
  brand70: '#0055D4',
  brand80: '#005EEB',
  brand90: '#0B6DFF',
  brand100: '#2A7FFF',
  brand110: '#4A92FF',
  brand120: '#69A5FF',
  brand130: '#88B8FF',
  brand140: '#A7CAFF',
  brand150: '#C7DDFF',
  brand160: '#E6F0FF',
  
  // Grey colors
  black: '#000000',
  grey190: '#201F1E',
  grey180: '#252423',
  grey170: '#292827',
  grey160: '#323130',
  grey150: '#3B3A39',
  grey140: '#484644',
  grey130: '#605E5C',
  grey120: '#797775',
  grey110: '#8A8886',
  grey90: '#A19F9D',
  grey70: '#BEBBB8',
  grey60: '#C8C6C4',
  grey50: '#D2D0CE',
  grey40: '#E1DFDD',
  grey30: '#EDEBE9',
  grey20: '#F2F2F1',
  grey10: '#FAF9F8',
  white: '#FFFFFF',
};
